package one.healthium.domain.user.models

import kotlin.time.Duration
import kotlin.time.Duration.Companion.days
import kotlin.time.Duration.Companion.hours
import kotlin.time.Duration.Companion.minutes
import kotlin.time.Duration.Companion.seconds

enum class PlayTime(
    val code: Int,
    val description: String,
    val minDuration: Duration,
    val maxDuration: Duration?
) {
    UNDECLARED(0, "Engagement time is undeclared", Duration.ZERO, Duration.ZERO),
    LESS_THAN_5_MIN(1, "Between 0–5 minutes", 1.seconds, 5.minutes),
    BETWEEN_5_MIN_AND_1_HOUR(2, "Between 5–60 minutes", 5.minutes, 60.minutes),
    BETWEEN_1_AND_6_HOURS(3, "Between 1–6 hours", 60.minutes, 6.hours),
    BETWEEN_6_AND_24_HOURS(4, "Between 6–24 hours", 6.hours, 24.hours),
    BETWEEN_1_AND_4_DAYS(5, "Between 1–4 days", 24.hours, 4.days),
    BETWEEN_4_AND_16_DAYS(6, "Between 4–16 days", 4.days, 16.days),
    MORE_THAN_16_DAYS(7, "Over 16 days", 16.days, null);

    companion object {
        fun fromSeconds(seconds: Long): PlayTime {
            val duration = seconds.seconds
            return values().find { it.minDuration <= duration && (it.maxDuration == null || duration < it.maxDuration) }
                ?: UNDECLARED
        }
    }
}